import { useAutopilotContext } from '@/composables/useAutopilotContext';
import type { WizardStepKey } from '@/stores/orderCreation';

export interface AutopilotWizardStep {
  /** step key, matches `booking_wizard.current_step` */
  key: WizardStepKey;
  /** step title as the user sees it (ui language), so the model can match the user's words */
  title: string;
  /** what the step is for and what the user decides here, written for the model */
  description: string;
  /** step-specific: options, switches, current values, hints */
  on_screen?: unknown;
}

/**
 * Publishes the order wizard step currently on screen under `context.booking_step`. Every step
 * calls this, so the assistant can always answer "what is this?" / "what's the difference?" about
 * the visible step instead of only knowing its key. Only one step is mounted at a time, and the
 * ownership in `useAutopilotContext` keeps the hand-off between steps clean.
 */
export function useAutopilotWizardStep(source: () => AutopilotWizardStep) {
  return useAutopilotContext('booking_step', source);
}
